import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FacialServices from "./components/FacialServices";
import EyebrowServices from "./components/EyebrowServices";
import Differentials from "./components/Differentials";
import Testimonials from "./components/Testimonials";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <FacialServices />
        <EyebrowServices />
        <Differentials />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}